import { lazy } from "react";

// project-imports
import Loadable from "components/Loadable";
import { routeConstants } from "services/keyConstants";

const View = Loadable(lazy(() => import("../View")));
const IQASchedule = Loadable(lazy(() => import("../IQASchedule")));
const ListOfAuditors = Loadable(lazy(() => import("../ListOfAuditors")));
const IQAPlan = Loadable(lazy(() => import("../IQAPlan")));
const IQAReport = Loadable(lazy(() => import("../IQAReport")));
const CAR = Loadable(lazy(() => import("../CAR")));

// ==============================|| AUTH ROUTES ||============================== //

const NewIQARoutes = [
  {
    path: routeConstants.IQA,
    children: [
      { path: "iqa-schedule-list", element: <IQASchedule /> },
      { path: "audtior-list", element: <ListOfAuditors /> },
      { path: "iqa-plan-list", element: <IQAPlan /> },
      { path: "iqa-report-list", element: <IQAReport /> },
      { path: "car-list", element: <CAR /> },
      { path: "view/:id", element: <View /> },
    ],
  },
];

export default NewIQARoutes;
